import { useEffect, useState } from "react";
import "./App.scss";
import {
  Navigate,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Layout, Result, message, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./components/Sidebar";
import MyHeader from "./components/MyHeader";
import PrivateRoute from "./components/PrivateRoute";
import {
  removeToken,
  setCallbackUrl,
  setRedirectUrl,
  setToken,
} from "./unit/index";
import MenuLoadingPage from "./components/MenuLoadingPage";
import Api from "./apis/index";
import { setUserInfo } from "./store/slices/userSlice";
import Scrollbars from "react-custom-scrollbars";
import { projectCode } from "./setting";
import _routers from "./router/index.js";
import { LeftOutlined } from "@ant-design/icons";
const { Content } = Layout;

function EmptyResult() {
  return (
    <div className="emptyResult">
      <Result status="404" title="404" subTitle="抱歉，您访问的页面不存在。" />
    </div>
  );
}
function App(props) {
  const { element } = props;

  const [breadcrumbName, setBreadcrumbName] = useState("");
  const [routers, setRouters] = useState([]);
  const [showRouters, setShowRouters] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const userInfo = useSelector((state) => state.user.userInfo) || {};

  const [personalMenus, setPersonalMenus] = useState(null);
  const [licenseName, setLicenseName] = useState(null);
  const [userMenus, setUserMenus] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (pageLoading) {
      return;
    }
    getUserInfo();
    getUserMenus();
    getMenuOfPersonal();
  }, [pageLoading]);

  useEffect(() => {
    // console.log('=====',location);
    if (routers?.length === 0) {
      return;
    }
    let route =
      routers.find((item) => item.menu_url === location.pathname) || null;
    if (!route) {
      routers.forEach((_) => {
        if ((_.children || [])?.length > 0 && !route) {
          route =
            _.children?.find((item) => item.menu_url === location.pathname) ||
            null;
        }
      });
    }
    setBreadcrumbName(route?.menu_name);
  }, [location, routers]);

  //获取用户信息
  const getUserInfo = async () => {
    let { data } = await Api.getUserInfo();
    if (!data) {
      logout();
      return;
    }
    dispatch(setUserInfo(data));
  };

  //获取用户菜单
  const getUserMenus = () => {
    Api.getMenus().then((res) => {
      if (res.code === 200) {
        const menusItem = res?.data?.find((_) => _.menu_code === projectCode);
        if (!menusItem) {
          // message.error('未匹配到本项目的目录数据!');
          setRouters([]);
          const findItem = (res.data || [])?.find((i) => i.menu_url);
          setCallbackUrl(window.location.href);
          //订阅过项目 跳到订阅的项目里
          if (findItem) {
            //findItem.menu_url
            window.location.href = localStorage.getItem("other_sub_url");
          } else {
            //没订阅过 跳到详情页
            window.location.href = localStorage.getItem("sub_url");
          }
          return;
        }

        let showRouters = [];
        const __routers = menusItem?.children?.map((menu) => {
          if (menu?.children?.length > 0) {
            menu.children = menu?.children?.map((_menu) => {
              let menuItem = _routers?.find(
                (_) =>
                  _.menu_name === _menu.menu_name ||
                  _.menu_code === _menu.menu_code
              );
              //iframe嵌外部界面 统一显示组件
              if (_menu?.open_mode === "IFRAME") {
                menuItem = _routers?.find((_) => _.menu_name === "外部界面");
              }
              if (!_menu.icon) {
                _menu.icon = menuItem?.icon;
              }
              _menu.element = menuItem?.element || <EmptyResult></EmptyResult>;
              if (_menu.menu_url) {
                _menu.open_url = _menu.menu_url;
                //如果menu_url带参数则去掉参数 保留原值为 open_url
                let _menu_url = _menu.menu_url;
                let _index = _menu.menu_url?.indexOf("?");
                if (_index !== -1) {
                  _menu_url = _menu.menu_url?.slice(0, _index);
                }
                _menu.menu_url = _menu_url;
                showRouters.push(_menu);
              }
              return _menu;
            });
          }
          let menuItem = _routers?.find(
            (_) =>
              _.menu_name === menu.menu_name || _.menu_code === menu.menu_code
          );

          //iframe嵌外部界面 统一显示组件
          if (menu?.open_mode === "IFRAME") {
            menuItem = _routers?.find((_) => _.menu_name === "外部界面");
          }

          if (!menu.icon) {
            menu.icon = menuItem?.icon;
          }
          menu.element = menuItem?.element || <EmptyResult></EmptyResult>;
          if (menu.menu_url) {
            menu.open_url = menu.menu_url;
            //如果menu_url带参数则去掉参数 保留原值为 open_url
            let _menu_url = menu.menu_url;
            let _index = menu.menu_url?.indexOf("?");
            if (_index !== -1) {
              _menu_url = menu.menu_url?.slice(0, _index);
            }
            menu.menu_url = _menu_url;
            showRouters.push(menu);
          }
          return menu;
        });

        setShowRouters(showRouters);
        setRouters(__routers);
        setUserMenus(res?.data);
      } else {
        message.error(res.msg);
        setShowRouters([]);
        setUserMenus([]);
        setRouters([]);
      }
    });
  };

  //获取订阅权限菜单
  const getMenuOfPersonal = () => {
    Api.getMenuOfPersonal().then((res) => {
      if (res.code === 200) {
        setPersonalMenus(res.data?.menu_list);
        setLicenseName(res.data?.license_name);
      } else {
        setPersonalMenus([]);
        setLicenseName(null);
        message.error(res.message);
      }
    });
  };

  //退出
  const logout = () => {
    let redirect = window.location.href; // + "/login";
    Api.logout(redirect).then((res) => {
      // console.log(res.data.data.logout_url);
      removeToken();
      if (window.location.pathname !== "/login") {
        setRedirectUrl(window.location.href);
      }
      if (res?.data?.status === "redirect") {
        window.location.href = res.data.logout_url;
      }
      if (res.code == "3") {
        window.location.reload();
      }
    });
  };

  //切换企业成功回调
  const switchEnterpriseSuccessFunc = (data) => {
    setToken(data.token);
    navigate("/");
    window.location.reload();
  };

  //点击菜单回调
  const authCallBack = (type) => {
    console.log("authCallBack", type);
  };

  //点击菜单回调
  const contactBusinessCallBack = () => {
    if (localStorage.getItem("deploy") === "BOX") {
      return;
    }
    setCallbackUrl(window.location.href);
    window.open(localStorage.getItem("sub_url"), "sub_url");
  };

  //点击菜单回调
  const menuClickCallBack = (item) => {
    if (item.menu_name === "帮助中心") {
      window.open(
        item.menu_url + localStorage.getItem("product_name"),
        item?.menu_name
      );
      return true;
    }
  };
  if (pageLoading) {
    return <MenuLoadingPage setPageLoading={setPageLoading}></MenuLoadingPage>;
  }

  return (
    <div className="App">
      <MyHeader
        userInfo={userInfo}
        userMenus={userMenus}
        personalMenus={personalMenus}
        logoutBack={logout}
        logoUrl={localStorage.getItem("logo_url")}
        getUnreadNoticesFunc={Api.getUnreadNotices}
        getNoticesFunc={Api.getNotices}
        setReadNoticesFunc={Api.setReadNotices}
        deleteNoticesFunc={Api.deleteNotices}
        getUpdateLogList={Api.getUpdateLogList}
        getEnterpriseFunc={Api.getEnterprise}
        switchEnterpriseFunc={Api.switchEnterprise}
        switchEnterpriseCallBack={switchEnterpriseSuccessFunc}
        licenseName={licenseName}
        projectCode={projectCode}
        authCallBack={authCallBack}
        getAuthTimeFunc={Api.getLicenseValid}
        getAdminsFunc={Api.getAdmins}
        contactBusinessCallBack={contactBusinessCallBack}
        menuClickCallBack={menuClickCallBack}
        editCompName={Api.editCompName}
        showEquityPoints={true}
        getEquityPointsFunc={Api.getEquityPointsFunc}
        backElement={element ? <Tooltip title="返回首页"><div style={{ cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32 }} onClick={() => navigate('/home')}><LeftOutlined /></div></Tooltip> : undefined}
        // getLicenseFunc={Api.getLicense}
        // showNotice={false}
      ></MyHeader>
      <Layout className="my-layout">
        {element ? (
          element
        ) : (
          <>
            <Sidebar routerList={routers} userMenus={userMenus}></Sidebar>
            <Layout>
              {/* <MyHeader></MyHeader> */}
              {/* 面包屑 */}
              <div className="breadcrumb">{breadcrumbName}</div>
              <Content className="my-content">
                {/* {element} */}
                <Scrollbars
                  className="scrollbars"
                  autoHide={true}
                  autoHideTimeout={5000}
                  style={{ height: "100%", width: "100%" }}
                >
                  <div className="contentBox">
                    {showRouters.length > 0 ? (
                      <Routes key={location.key}>
                        {showRouters.map((item) => (
                          <Route
                            path={item.menu_url}
                            key={item.menu_url}
                            breadcrumbName={item.menu_name}
                            element={
                              <PrivateRoute menu_name={item.menu_name}>
                                {item.element}
                              </PrivateRoute>
                            }
                          />
                        ))}
                        <Route
                          path="/*"
                          element={<Navigate to={showRouters[0]?.menu_url} />}
                        />
                      </Routes>
                    ) : null}
                  </div>
                </Scrollbars>
              </Content>
            </Layout>
          </>
        )}
      </Layout>
    </div>
  );
}

export default App;
